import ServicesImageAbstract from "./ServicesImageAbstract";
import Math_ from "../../../../assets/src/js/app/utils/Math";

export default class ServicesImagesConseil extends ServicesImageAbstract {
	constructor($wrapper) {
		super($wrapper);
		this.rotation1 = 2;
		this.rotation2 = -2;
		this.init();
	}

	updateCanvas() {
		const velocity = this.velocity >= 0 ? Math_.clamp(this.velocity * 0.0003, 0.01, 0.05) : Math_.clamp(this.velocity * 0.0003, -0.05, -0.01);
		this.rotation1 -= velocity;
		this.rotation2 += velocity;
		// this.rotation1 += 0.1;
		// this.rotation2 -= 0.1;

		const blue = '#4545FF',
			opacity = 0.5;

		// RESET
		this.ctx.resetTransform();
		this.ctx.moveTo(0, 0);
		this.ctx.clearRect(0, 0, this.size, this.size);
		this.ctx.fillStyle = blue;
		this.ctx.globalAlpha = opacity;
		this.ctx.globalCompositeOperation = 'source-over';
		let x, y;

		// FIRST
		x = ((this.size * 0.1) * (Math.sin(this.rotation1)));
		y = ((this.size * 0.1) * (Math.cos(this.rotation1)));
		this.ctx.translate(this.size * 0.6, this.size * 0.4);
		this.ctx.beginPath();
		this.ctx.arc(x, y, this.size * 0.3, 0, 2 * Math.PI);
		this.ctx.fill();

		// SECOND
		x = ((this.size * 0.1) * (Math.cos(this.rotation2)));
		y = ((this.size * 0.1) * (Math.sin(this.rotation2)));
		this.ctx.resetTransform();
		this.ctx.translate(this.size * 0.4, this.size * 0.6);
		this.ctx.beginPath();
		this.ctx.arc(x, y, this.size * 0.3, 0, 2 * Math.PI);
		this.ctx.fill();

	}
}
